import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
var CustomHelmet = function (_a) {
    var tubeName = _a.tubeName;
    // This is used to add the name into the manifest file while installing into android devices.
    var manifest = {
        short_name: tubeName + " TrainingTube",
        name: tubeName + " TrainingTube",
        icons: [
            {
                src: 'logo.png',
                sizes: '64x64 32x32 24x24 16x16',
                type: 'image/png',
            },
        ],
        start_url: './index.html',
        display: 'standalone',
        theme_color: '#000000',
        background_color: '#ffffff',
    };
    var stringManifest = JSON.stringify(manifest);
    var blob = new Blob([stringManifest], { type: 'application/json' });
    var manifestURL = URL.createObjectURL(blob);
    document.querySelector('#manifest-placeholder').setAttribute('href', manifestURL);
    return (React.createElement(Helmet, null,
        React.createElement("title", null,
            tubeName,
            " TrainingTube")));
};
var mapStateToProps = function (state, ownProps) { return ({
    tubeName: state.auth.organization.name,
}); };
export default connect(mapStateToProps)(CustomHelmet);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/Helmet.tsx
// module id = 2026
// module chunks = 81